const getters = {
    sidebar: state => state.app.sidebar,
    device: state => state.app.device,
    userInfo: state => state.user.userInfo?.user,
    userTenantId: state => state.user.userInfo?.tenant.id,
    customFormList: state => state.custom_form.customList,
    selectedInputType: state => state.custom_form.selectedInputType,
    ruleConditions: state => state.rule_conditions.ruleConditions,
    authToken: state => state.auth.authToken,
    accessToken: state => state.auth.accessToken,
    qrCanvasDesign: state => state.barcode_conf.qrCanvasDesign,
    qrCodeDesign: state => state.barcode_conf.qrCodeDesign,
    qrDescDesign: state => state.barcode_conf.qrDescDesign,
    breadcrumbExtraInfo: state => state.breadcrumb.breadcrumbExtraInfo,
    barcodeSettings: state => state.barcode_settings,
    infoSidebar: state => state.info_sidebar,
    isInfoSidebarShown: state => state.info_sidebar.info_sidebar,
    info_sidebar_id: state => state.info_sidebar.info_sidebar_id,
    info_details: state => state.info_sidebar.info_details,
    CustomFieldFilter: state => state.table_filter.CustomFieldFilter,
    CustomFieldFilterChip: state => state.table_filter.CustomFieldFilterChip,
    CustomFieldData: state => state.custom_field_data.customFieldData,
    CustomFieldExtraData: state => state.custom_field_data.customFieldExtraData,
    EditCustomFieldData: state => state.custom_field_data.editCustomFieldData,
    isDataFilter: state => state.data_filter.isDataFilter,
    dataFilter: state => state.data_filter.dataFilter,
    currentUser: state => state.current_user.currentUser,
    visibleFieldHeader: state => state.field_header.visibleFieldHeader,
    hiddenFieldHeader: state => state.field_header.hiddenFieldHeader,
    configureTableData: state => state.field_header.configureTableData,
    recordingAnalysisDataInfo: state => state.recording_data,
    dashboardLayout: state => state.dashboard_layout.layout,
    dynamicDialogVisible: state => state.custom_field_data.dynamicDialogVisible,
    chartConfiguration: state => state.personalize_dashboard.chartConfiguration,
    sortSettings: state => state.user_settings.sortSettings,
    publicThankYouMessage: state => state.public_thank_you_message.publicThankYouMessage,
    currentConfigureCardType: state => state.personalize_dashboard.currentConfigureCardType,
    userNotifications: state => state.signalr.notifications?.items,
    totalNotificationCount: state => state.signalr.notifications?.totalCount,
    unreadNotificationCount: state => state.signalr.unreadNotificationCount,
    displayUnreadNotificationCount: state => state.signalr.displayUnreadNotificationCount,
    germinatedSeedTransactionTypes: state => state.germinatedSeedTransaction.germinatedSeedTransactionTypes,
    germinatedSeedTransactionDetail: state => state.germinatedSeedTransaction.germinatedSeedTransactionDetail,
    forms: state => state.form_store.forms,
    pollen_workflow_forms: state => state.form_store.pollen_workflow_forms,
    bunch_workflow_forms: state => state.form_store.bunch_workflow_forms,
    formGrouped: state => state.form_store.formGrouped,
    freshSeedTransactionTypes: state => state.freshSeedTransaction.freshSeedTransactionTypes,
    progenyOptions: state => state.progeny.progenyOptions,
    bunchOptions: state => state.bunch.bunchOptions,
    stationOptions: state => state.station.stationOptions,
    countryOptions: state => state.country.countryOptions,
    crossTypeOptions: state => state.crossType.crossTypeOptions,
    materialOptions: state => state.material.matrialOptions,
    matingDesignOptions: state => state.matingDesign.matingDesignOptions,
    freshSeedTransactionDetail: state => state.freshSeedTransaction.freshSeedTransactionDetail,
    selectedCPCrossTypeId: state => state.createProgrammeSteps.selectedCPCrossTypeId,
    selectedFemalePalms: state => state.createProgrammeSteps.selectedFemalePalms,
    selectedMalePalms: state => state.createProgrammeSteps.selectedMalePalms,
    crossingProgenies: state => state.createProgrammeSteps.crossingProgenies,
    freshSeedBagDetail: state => state.freshSeedBag.freshSeedBagDetail,
    germplasmOptions: state => state.germplasm.germplasmOptions,
    germinatedSeedBagOptions: state => state.germinatedSeedBag.germinatedSeedBagOptions,
    speciesOptions: state => state.species.speciesOptions,
    createdFormInfo: state => state.form_store.createdFormInfo,
    generalFilter: state => state.general_filter.generalFilter,
    freshSeedBagOptions: state => state.freshSeedBag.freshSeedBagOptions,
    germinationBatchOptions: state => state.germinationBatch.germinationBatchOptions,
    pollenBottleTransactionTypes: state => state.pollenBottleTransaction.pollenBottleTransactionTypes,
    pollenBottleOptions: state => state.pollenBottle.pollenBottleOptions,
    crossTypeIdsInCrossingProgram: state => state.crossing_program.crossTypeIdsInCrossingProgram,
    fruitTypeOpts: state => state.fruit_type.fruitTypeOpts,
};

export default getters;
  


// WEBPACK FOOTER //
// ./src/vuex/getters.js